module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.opened) ? _c('div', {
    staticClass: "u-bg-overlay"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-theme-config-container",
    class: {
      'is-closed': _vm.opened
    }
  }, [_c('div', {
    staticClass: "u-theme-config-panel",
    class: {
      'open': _vm.opened
    }
  }, [(_vm.opened) ? _c('div', {
    staticClass: "u-theme-content"
  }, [_vm._v("\n\n        Tem certeza que deseja alterar o status?"), _c('br'), _c('br'), _vm._v("\n\n        De "), _c('span', {
    staticClass: "label text-sm",
    class: 'bg-' + _vm.getStatus[_vm.oldStatus].class
  }, [_vm._v(_vm._s(_vm.getStatus[_vm.oldStatus].titulo))]), _vm._v("\n        para "), _c('span', {
    staticClass: "label text-sm",
    class: 'bg-' + _vm.getStatus[_vm.newStatus].class
  }, [_vm._v(_vm._s(_vm.getStatus[_vm.newStatus].titulo))]), _vm._v(" "), _c('p', {
    staticClass: "m-t-xl"
  }, [_c('button', {
    ref: "btn",
    staticClass: "btn btn-success",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cancelar")])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e7c076a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/arematantes/components/ConfirmStatus.vue
// module id = 1782
// module chunks = 17